// dependencies
import { endOfDay, format } from "date-fns";
import React from "react";

// components
import Text from "../../../../../../components/Text";
import { CardHeader } from "../../../../components/Card";
import BreakdownChart from "./BreakdownChart";

// store
import useStore from "../../../../store";

// hooks
import { useNPSAdditionalFeedback } from "../../../../../../api/hooks";

// utils
import downloadCSV from "../../../../../../utils/downloadCSV";
import escapeCsvField from "../../../../../../utils/escapeCsvField";

// config
import Config from "../../../../Config";

const EnpsBreakdownChart = () => {
	const [filter] = useStore((state) => [state.filter]);

	const { data: npsAdditionalFeedbackData } = useNPSAdditionalFeedback({
		startDate: filter.startDate,
		endDate: filter.endDate || endOfDay(new Date()),
	});

	const additionalFeedback = npsAdditionalFeedbackData?.data;

	const getCSVContent = () => {
		if (!additionalFeedback?.length) return "";
		const csvColumns = ["eNPS Score", "Additional Feedback", "Response Date"];

		const csvRows = additionalFeedback.map((feedback) => [
			feedback.enps_value,
			escapeCsvField(feedback.additional_feedback),
			format(new Date(feedback.submitted_at), "dd-MMM-yyyy"),
		]);

		return [csvColumns, ...csvRows].join("\n");
	};

	const selectCSVDownloadName = () => {
		const date = new Date().toDateString();
		const timePeriod = Config.FILTER_OPTIONS.find((option) => option.value === filter.value)?.label;
		return `PerformYard-Engagement-eNPS-AdditionalFeedback-${timePeriod}-${date}.csv`;
	};

	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							eNPS Breakdown
						</Text>
					</span>
				}
				info="This chart displays the eNPS Breakdown."
				options={
					additionalFeedback && additionalFeedback.length > 0
						? [
								{
									id: "download-csv",
									label: "Download CSV",
									action: () => {
										const csvContent = getCSVContent();
										const filename = selectCSVDownloadName();
										return downloadCSV(csvContent, filename);
									},
								},
							]
						: undefined
				}
			/>
			<BreakdownChart />
		</>
	);
};

export default EnpsBreakdownChart;
